module.exports = __webpack_public_path__ + "img/MEDIA082.26154326.jpg";